import React from 'react';
import { AccordionDetails, Typography, Box, Card, Chip } from '@material-ui/core';
import moment from 'moment';
import EventRoundedIcon from '@material-ui/icons/EventRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import { dateMonthYearDateFormat } from '../config/whatsNewConfig';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');

const ReleaseCard = ({ item, accent, artwork, isLatestRelease, releaseEnhancement, releaseStatus }) => {
    const accentVars = { '--accent': accent.main, '--accent-soft': accent.soft, '--accent-glow': accent.glow };

    return (
        <Box className="whats-new-timeline-item" style={accentVars}>
            <Box className="whats-new-timeline-marker"><EventRoundedIcon /></Box>
            <Card elevation={0} className="whats-new-release-card">
                <Box className="whats-new-release-card-body">
                    {artwork && (
                        <Box className={cx('whats-new-release-artwork', artwork.src && 'has-image')}>
                            {artwork.isHome ? <HomeRoundedIcon aria-label={artwork.alt} /> : <Box component="img" src={artwork.src} alt={artwork.alt} className="whats-new-release-artwork-img" />}
                        </Box>
                    )}
                    <Box className="whats-new-release-meta">
                        <Box className="whats-new-release-date-status">
                            <Chip label={moment(item.release_date).format(dateMonthYearDateFormat)} size="small" className="whats-new-release-date-chip" />
                            <Box className={cx('whats-new-release-status', releaseStatus.className)}>
                                <Box component="span" className="whats-new-release-status-dot" />
                                <Typography component="span" className="whats-new-release-status-label">{releaseStatus.label}</Typography>
                            </Box>
                        </Box>
                        {item?.application?.label && (
                            <Chip label={`Application: ${item.application.label}`} size="small" className="whats-new-release-application-chip" />
                        )}
                        {isLatestRelease && <Chip label="LATEST" size="small" className="whats-new-release-latest-chip" />}
                    </Box>
                    <Typography className={cx('whats-new-release-title', artwork && 'whats-new-release-title-with-artwork')}>
                        {item.title}
                    </Typography>
                    <AccordionDetails className="whats-new-release-description-wrap">
                        <Typography component="div" className="whats-new-release-description" dangerouslySetInnerHTML={{ __html: item.description }} />
                    </AccordionDetails>
                    {releaseEnhancement && (
                        <Box className="whats-new-release-highlights">
                            <Box className="whats-new-release-highlights-grid">
                                {releaseEnhancement.highlights.map(highlight => (
                                    <Box key={highlight} className="whats-new-release-highlight">
                                        <Typography component="span" className="whats-new-release-highlight-check">✓</Typography>
                                        <Typography component="span" className="whats-new-release-highlight-text">{highlight}</Typography>
                                    </Box>
                                ))}
                            </Box>
                            <Box className="whats-new-release-info-pills">
                                <Chip label={`Module: ${releaseEnhancement.module}`} size="small" className="whats-new-release-info-pill" />
                                <Chip label={`Users: ${releaseEnhancement.users}`} size="small" className="whats-new-release-info-pill" />
                            </Box>
                        </Box>
                    )}
                </Box>
            </Card>
        </Box>
    );
};

export default ReleaseCard;